"use strict";

exports.__esModule = true;
var _DashboardThumbnail = require("./DashboardThumbnail");
Object.keys(_DashboardThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardThumbnail[key]) return;
  exports[key] = _DashboardThumbnail[key];
});